// extracted by mini-css-extract-plugin
export default {"column":"TableColumn_column__0Q-7H"};